module.exports = __webpack_public_path__ + "static/images/footerlogo_en_d3c1350c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footerlogo_en.png
// module id = 227
// module chunks = 1